export default __webpack_public_path__ + "static/media/instagram (1).2c37a341.svg";